/**
 * Created by comoon on 2/17/16.
 */

var React = require('react');

var ReactDOM = require('react-dom');

var $ = require("jquery");


var TipBox = React.createClass({
    displayName: "TipBox",
    render(){
        return (
            <div className="comoon-tip-implementer">
                {
                    this.props.title ?
                        (<div className="comoon-tip-title">
                            {this.props.title}
                        </div>)
                        : null
                }
                <div className="comoon-tip-content">
                    {this.props.children}
                </div>
            </div>
        );
    }
});

module.exports = React.createClass({
    displayName: "Tip",

    getDefaultProps: function () {
        return {
            delay: 100
        };
    },
    propTypes: {

        /**
         * 将会被render到页面的元素
         * 通过此元素触发Tip的显示
         * 必须
         */
        trigger: React.PropTypes.element.isRequired,

        /**
         * Tip的title
         * 非必须
         */
        title: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),

        /**
         * Tip显示的内容
         * 必须
         */
        children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.element.isRequired), React.PropTypes.element.isRequired]),

        /**
         *  Tip的内容是光标可进入的
         *  设置为true时, 鼠标可以在tip里面进行操作
         *  非必须
         */
        enter: React.PropTypes.bool,

        /**
         * 如果设定了enter,
         * 从trigger到tip, 默认delay多长时间关闭tip
         * 单位: mills
         * 非必须
         */
        delay: React.PropTypes.number,

        /**
         * Tip将被放置到的容器, 默认为body,且通常不需要设定
         * 非必须
         */
        container: React.PropTypes.node,

        /**
         * Tip将跟随页面上的哪个元素, 默认为trigger, 且通常不需要设定
         * 非必须
         */
        target: React.PropTypes.node,

        /**
         * 设定开发者选项, 在hover离开时, Tip不关闭
         * 非必需
         */
        dev: React.PropTypes.bool
    },
    componentDidMount(){
        var self = this;
        var trigger = ReactDOM.findDOMNode(self);
        self.__opening = false;
        var holder = this.holder = self.__tipHolder = $("<div class='comoon-tip-holder'></div>");
        self.__showTips = function () {
            var container = (self.props.container && ReactDOM.findDOMNode(self.props.container)) || document.querySelector('body');
            var target = $((self.props.target && ReactDOM.findDOMNode(self.props.target)) || trigger);
            self.__closeTimer();

            if (self.__opening) {
                return;
            }
            self.__opening = true;
            holder.appendTo(container);
            var implementer = (<TipBox {...self.props} />);
            ReactDOM.render(implementer, holder[0]);
            //响应元素
            var triggerOffset = target.offset();
            var targetLeft = triggerOffset.left;
            //tips宽
            var holerWidth = holder.width();
            var winWidth = $(window).width();
            var left = (targetLeft+holerWidth)>winWidth ?  targetLeft-holerWidth : targetLeft;
            holder.css('top', triggerOffset.top).css('left', left);
            self.__repositonChooser = function () {
                var triggerOffset = target.offset();
                var targetLeft = triggerOffset.left;
                var left = (targetLeft+holerWidth)>winWidth ?  targetLeft-holerWidth : targetLeft;
                holder.css('top', triggerOffset.top).css('left', left);
            };
            var win = $(window);
            win.on('resize', self.__repositonChooser);
            win.on('scroll', self.__repositonChooser);
        };

        self.__closeTips = function () {

            var closeTip = function () {
                if (self.props.dev) {

                    return;
                }

                self.__opening = false;
                var win = $(window);
                win.off('resize', self.__repositonChooser);
                win.off('scroll', self.__repositonChooser);

                self.__repositonChooser = null;

                delete self.__repositonChooser;

                ReactDOM.unmountComponentAtNode(holder[0]);

                holder.detach();
            };


            if (!self.props.enter) {

                closeTip();

            } else {

                self.__timer = setTimeout(function () {

                    closeTip();

                    self.__timer = null;

                    delete self.__timer;

                }, self.props.delay);
            }
        };

        self.__closeTimer = function () {

            if (self.__timer) {

                clearTimeout(self.__timer);

                self.__timer = null;

                delete self.__timer;
            }
        };

        holder.on("mouseover", self.__closeTimer);

        holder.on("mouseout", self.__closeTips);

        $(trigger).on("mouseover", self.__showTips);

        $(trigger).on("mouseout", self.__closeTips);

    },
    componentWillUnmount(){
        var self = this;

        var trigger = $(ReactDOM.findDOMNode(self));

        var holder = self.__tipHolder;

        trigger.off("mouseover", self.__showTips);

        trigger.off("mouseout", self.__closeTips);

        holder.off("mouseover", self.__closeTimer);

        holder.off("mouseout", self.__closeTips);

        self.__showTips = null;

        self.__closeTips = null;

        self.__closeTimer = null;

        delete self.__showTips;

        delete self.__closeTips;

        delete self.__closeTimer;

        self.__tipHolder.remove();

        self.__tipHolder = null;

        delete self.__tipHolder;

        delete self.__opening;
    },
    componentWillReceiveProps(nextProps){
        var implementer = (<TipBox {...nextProps} />);
        ReactDOM.render(implementer, this.holder[0]);
    },
    render(){
        return this.props.trigger;
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/cutil/Tip.jsx
 **/